module.exports = __webpack_public_path__ + "img/Ixmucané Aguilar.921488aa.jpg";